import React from 'react';
import './compareTable.scss';
import CompareValue from './compareValue.jsx';

const CompareTable = (props) => {
  return (
    <div className="ontario-row">
      <div
        className={
          'ontario-column ontario-small-12 ontario-medium-12  ontario-margin-top-24-!'
        }
      >
        {props.data && (
          <>
            <div className={`cviz-compare-value`}>
              {props.columns &&
                props.columns.map((item, i) => {
                  return item.title === '' ? (
                    <div
                      key={i}
                      className={`cviz-compare-value--label`}
                    ></div>
                  ) : (
                    <div
                      key={i}
                      className={`cviz-compare-value--value`}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item.title,
                        }}
                      />
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item.subTitle,
                        }}
                      />
                    </div>
                  );
                })}
            </div>
            <ul className="ontario-no-bullet cviz-overview-list">
              {props.data &&
                props.data.map((item, idx) => (
                  <li key={idx}>
                    <CompareValue
                      remOnClick={props.remOnClick}
                      name={item.name}
                      label={item[props.columns[0].dataIndex]}
                      values={props.columns.map((col, i) => {
                        if (i > 0) {
                          return item[col.dataIndex];
                        }
                      })}
                      lang={props.lang}
                    />
                  </li>
                ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
};

export default CompareTable;
